import { useEffect, useState } from "react";
// import ReactTooltip from "react-tooltip"; // TOOLTIP POSITIONING ENGINE!: popper.js.org

import styles from "./TemplateMonitorRow.module.css";
import gStyles from "./TemplateMonitorGlobalStyles.module.css";

const TemplateMonitorRowCF = (props) => {
  const [title, setTitle] = useState(props.title);
  const [displayButton, setDisplayButton] = useState(false);
  // const [pos, setPos]
  // const [questionType, setQuestionType] = useState(props.questionType);
  // const [questionTypeSelected, setQuestionTypeSelected] = useState(false);
  // const [displayQuestionTypeButtons, setDisplayQuestionTypeButtons] = useState(false);

  useEffect(() => {
    setTitle(props.title);
    // console.log("pos: ", pos, " type: ", type ? (`${type} ${title ? title.substring(0,20) : "no title"}`) : (`question: ${title ? title.substring(0,20) : ""}`))
    // setQuestionType(props.questionType);
  }, [props]);

  const showQuestionButtons = () => {
    setDisplayButton(true);
  };

  const hideQuestionButtons = () => {
    setDisplayButton(false);
  };

  // const buttonStyle = `${styles.Button} ${styles.checkedButton}`;
  let titleStyle = "";
  let type = props.type;
  let pos = props.pos; // position/index of row in the array
  if (type === "principio") {
    titleStyle = styles.principio;
  }
  else if (type === "requisito") {
    titleStyle = styles.requisito;
  }
  else if (type === "ambito") {
    titleStyle = styles.ambito;
  }

  const elementDropdownArrow = (
    <div
      className={`${styles.dropdownArrowContainer} overflow-visible p-0`}
    >
      <button
        onClick={
          () => {
            props.collapseElement(pos, !props.isCollapsed)
          }
        }
        className={`${styles.dropdownArrow} ${props.isCollapsed ? styles.down : styles.up} ${displayButton ? "visible" : "invisible"}`}
      ></button>
    </div>
  );

  return (
    <tr
      onMouseEnter={showQuestionButtons}
      onMouseLeave={hideQuestionButtons}
    >
      <td
        className={`
          ${titleStyle}  
          ${styles.questionsWidth} 
          ${type && (styles.cursorPointer + ' ' + styles[`${type}Hover`])} 
          ${props.isCollapsed && (props.hasValidChildren ? styles[`${type}Valid`] : styles[`${type}Invalid`])}
          fw-bold text-start position-relative px-2`}
        data-tip=""
        onClick={
          () => {
            if (type) {
            props.collapseElement(pos, !props.isCollapsed);
          }
          }
        }
      >
        {type && elementDropdownArrow}
        {!type ? (
          <div className="d-flex">
            {props.isQualitative && <div className={`${styles.questionId} pe-2 me-2`}>{props.principioId}.{props.displayId && props.displayId}</div>}
            <textarea defaultValue={title} disabled className={`${styles.titleFieldDisplay} fw-bold m-0`} />
          </div>
          // <p className="m-0" style={{maxHeight: "60px", overflowX: "hidden", overflowY: "scroll"}}>{title}</p>
        ) : (
          <p className="m-0 mb-2">{title}</p>
        )}
      </td>
      <td className={styles.whiteSpaceHeader}></td>
      {props.opScopes.map(os => (
        <td className={`${gStyles.opScopeWidth} ${props.type === "ambito" && !props.isActive && styles.disabledAttrBtn} ${!props.isQualitative && !props.type && !props.isActive && styles.disabledAttrBtn} ${(!type && props.invalidInputs.allOpAreasAreUnchecked) ? styles.invalidInput : ""}`} key={pos + "-" + os.name}>
          <button
            // the value of the field determines if the checked symbol is shown
            className={os.enabled ? styles.checkedButton : styles.uncheckedButton}
            // return the operational scope field which is on string format
            disabled={props.isActive === false}
            onClick={() => {
              os.enabled
                ? props.uncheckingOpScope(pos, type, props.cfId, os.id, props.isQualitative)
                : props.checkingOpScope(pos, type, props.cfId, os.id, props.isQualitative);
            }}
          ></button>
        </td>
      ))}
    </tr>
  );
};

export default TemplateMonitorRowCF;
